<!-- App Header -->
<header class="app-header" [ngStyle]="isHMRole ? {'justify-content': 'flex-end'} : {'justify-content': 'space-between'}">
   <!-- Center: Global Search -->
<div class="header-center" [class.mobile-open]="showMobileSearch" *ngIf="!isHMRole">
   <div class="global-search" (click)="$event.stopPropagation()">
       <!-- Commented the  code temporarily -->
      <div class="search-input-box">
        <i class="pi pi-search search-icon"></i>
        <input
          type="text"
          placeholder="Search VetCor..."
          [value]="searchQuery"
          (input)="onSearchInput($event)"
          (focus)="onSearchFocus()"
          (keydown.enter)="viewAllResults()" />

        <div class="search-actions">
           <i *ngIf="!searchQuery" class="pi pi-globe global-indicator" title="Global Search"></i>
           <button *ngIf="searchQuery" class="clear-btn" (click)="$event.stopPropagation(); clearSearch()">
              <i class="pi pi-times"></i>
           </button>
        </div>
      </div>

      <!-- Search Dropdown -->
      <div class="search-dropdown" *ngIf="showSearchDropdown">
         <div *ngIf="isSearchLoading" class="search-feedback">
            <mat-spinner diameter="24"></mat-spinner>
            <span>Searching...</span>
         </div>
         <div *ngIf="isSearchError" class="search-feedback error">
            <i class="pi pi-exclamation-circle"></i>
            <span>Search failed. Please try again.</span>
         </div>

         <div *ngIf="!isSearchLoading && !isSearchError" class="search-results">
            <div *ngIf="!hasSearchResults() && searchQuery.trim()" class="search-feedback empty">
               <span>No results found for "{{searchQuery}}"</span>
            </div>
            <div *ngIf="!hasSearchResults() && !searchQuery.trim()" class="search-feedback empty">
               <span>Type to start searching...</span>
            </div>

            <div class="results-scroll-area" *ngIf="hasSearchResults()">
               <!-- Goals Group -->
               <div class="result-group" *ngIf="searchResults?.goals?.length > 0">
                  <div class="group-title">Goals</div>
                  <div class="result-item" *ngFor="let item of searchResults.goals" (click)="navigateToResult(item)">
                     <div class="icon-box goal"><i class="pi pi-bullseye"></i></div>
                     <div class="item-text">
                        <span class="item-name">{{item.title}}</span>
                        <span class="item-desc" [innerHTML]="item.snippet"></span>
                     </div>
                  </div>
               </div>

               <!-- Tasks Group -->
               <div class="result-group" *ngIf="searchResults?.tasks?.length > 0">
                  <div class="group-title">Tasks</div>
                  <div class="result-item" *ngFor="let item of searchResults.tasks" (click)="navigateToResult(item)">
                     <div class="icon-box task"><i class="pi pi-check-square"></i></div>
                     <div class="item-text">
                        <span class="item-name">{{item.title}}</span>
                        <span class="item-desc" [innerHTML]="item.snippet"></span>
                     </div>
                  </div>
               </div>

               <!-- Meetings Group -->
               <div class="result-group" *ngIf="searchResults?.meetings?.length > 0">
                  <div class="group-title">Meetings</div>
                  <div class="result-item" *ngFor="let item of searchResults.meetings" (click)="navigateToResult(item)">
                     <div class="icon-box meeting"><i class="pi pi-calendar"></i></div>
                     <div class="item-text">
                        <span class="item-name">{{item.title}}</span>
                        <span class="item-desc" [innerHTML]="item.snippet"></span>
                     </div>
                  </div>
               </div>

               <!-- Hospitals Group -->
               <div class="result-group" *ngIf="searchResults?.hospitals?.length > 0">
                  <div class="group-title">Hospitals</div>
                  <div class="result-item" *ngFor="let item of searchResults.hospitals" (click)="navigateToResult(item)">
                     <div class="icon-box hospital"><i class="pi pi-building"></i></div>
                     <div class="item-text">
                        <span class="item-name">{{item.title}}</span>
                        <span class="item-desc">{{item.snippet}}</span>
                     </div>
                  </div>
               </div>
            </div>

            <button class="view-all-btn" *ngIf="hasSearchResults()" (click)="viewAllResults()">
               View All Results
            </button>
         </div>
      </div>
   </div>
</div>


  <!-- Right Side: Navigation, Profile, Notifications -->
  <div class="header-right">

    <nav class="main-nav">
      <a *ngFor="let item of navItems"
         [routerLink]="item.route"
         routerLinkActive="active"
         [routerLinkActiveOptions]="{ exact: true }"
         class="nav-link">
         <mat-icon class="nav-icon">{{ item.icon }}</mat-icon>
         <span class="nav-label">{{ item.label }}</span>
      </a>
    </nav>

    <div class="divider"></div>

    <div class="user-profile">
      <div class="user-text">
         <span class="name">{{ userNameData }}</span>
         <span class="role">{{ userRoleData }}</span>
      </div>
      <div class="avatar-ring">
        <img class="avatar" [src]="avatarUrl || 'https://ui-avatars.com/api/?name=' + userNameData + '&background=0f9d89&color=fff'" [alt]="userNameData" />
      </div>
    </div>

    <!-- Notifications -->
    <div class="notification-wrapper" (click)="notificationShow()">
      <div class="bell-icon-container" [class.has-notifications]="notifications.length > 0">
         <i class="pi pi-bell bell-icon"></i>
         <span class="badge" *ngIf="notifications.length > 0">{{ notifications.length > 99 ? '99+' : notifications.length }}</span>
      </div>

      <div class="notification-dropdown" *ngIf="showNotifications" (click)="$event.stopPropagation()">
         <div class="notif-header">
            <span>Notifications</span>
            <span class="notif-count" *ngIf="notifications.length > 0">{{ notifications.length }} new</span>
            <button class="close-btn" (click)="$event.stopPropagation(); showNotifications = false;"><i class="pi pi-times"></i></button>
         </div>

         <div class="notif-body">
            <div *ngIf="notifications.length === 0" class="notif-empty">
               <i class="pi pi-bell-slash notif-empty-icon"></i>
               <span>No notifications</span>
            </div>

            <div class="notif-item" *ngFor="let n of notifications">
               <div class="notif-content" (click)="taskNavigation(n)">
                  <span class="notif-title">{{ n.title }}</span>
                  <span class="notif-message">{{ n.content || '-' }}</span>
                  <span class="notif-time" *ngIf="n.createdAt">{{ n.createdAt | date:'MM/dd/yyyy hh:mm a' }}</span>
               </div>
               <button class="notif-close" (click)="$event.stopPropagation(); closeNotification(n.notificationId);">
                  <i class="pi pi-times"></i>
               </button>
            </div>
         </div>
      </div>
    </div>

    <!-- Mobile: search toggle -->
    <button class="icon-btn mobile-search-btn" (click)="$event.stopPropagation(); toggleMobileSearch()" [class.active]="showMobileSearch">
      <i class="pi pi-search"></i>
    </button>

    <!-- Mobile: hamburger -->
    <button class="icon-btn mobile-menu-btn" (click)="toggleMobileMenu()">
      <i [class]="showMobileMenu ? 'pi pi-times' : 'pi pi-bars'"></i>
    </button>
  </div>

  <!-- Mobile Nav Drawer (positioned fixed) -->
  <nav class="mobile-drawer" [class.open]="showMobileMenu" (click)="$event.stopPropagation()">
    <div class="drawer-user-card">
      <div class="avatar-ring">
        <img class="avatar" [src]="avatarUrl || 'https://ui-avatars.com/api/?name=' + userNameData + '&background=0f9d89&color=fff'" [alt]="userNameData" />
      </div>
      <div class="user-text">
        <span class="name">{{ userNameData }}</span>
        <span class="role">{{ userRoleData }}</span>
      </div>
    </div>

    <div class="drawer-nav-list">
      <a *ngFor="let item of navItems"
         [routerLink]="item.route"
         routerLinkActive="active"
         [routerLinkActiveOptions]="{ exact: true }"
         class="drawer-nav-link"
         (click)="showMobileMenu = false">
        <mat-icon class="nav-icon">{{ item.icon }}</mat-icon>
        <span>{{ item.label }}</span>
      </a>
    </div>
  </nav>

  <!-- Mobile Backdrop -->
  <div class="drawer-backdrop" *ngIf="showMobileMenu" (click)="showMobileMenu = false"></div>
</header>
